import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useDirectusAuth,
  useRuntimeConfig,
} from '#imports'

export default defineNuxtRouteMiddleware((to) => {
  const nuxtApp = useNuxtApp()
  const config = useRuntimeConfig().public.directus

  if (to.path === nuxtApp.$localePath(config.auth.redirect.login)) {
    const { _loggedIn, user } = useDirectusAuth()
    if (user.value) {
      return navigateTo({
        path: nuxtApp.$localePath(config.auth.redirect.home),
      })
    }
    return
  }

  if (
    config.auth.enableGlobalAuthMiddleware === true &&
    to.meta.auth === false
  ) {
    return
  }

  const { _loggedIn, user } = useDirectusAuth()

  //if user is not legged in and to is not a part of /portal
  if (!user.value) {
    return to.path.includes('/portal')
      ? navigateTo({
          path: nuxtApp.$localePath(config.auth.redirect.login),
          query: {
            redirect:
              to.path === nuxtApp.$localePath(to.path)
                ? undefined
                : nuxtApp.$localePath(to.path),
          },
        })
      : navigateTo({
          path: nuxtApp.$localePath('/'),
        })
  }
})
